export const styles = () => ({
  outerContainer: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 8,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 'auto',
    zIndex: 9999,
    background: 'rgba(53, 64, 82, 0.7)',
  },
  container: {
    background: '#F7F8FA',
    boxShadow: '0px 1px 0px rgba(53, 64, 82, 0.1)',
    width: '100%',
    borderRadius: 12,
    overflow: 'hidden',
  },
  header: {
    padding: '12px 16px',
    background: '#FFF',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px 1px 0px rgba(53, 64, 82, 0.1)',

    '& > svg': {
      cursor: 'pointer',
    },
  },
  main: {
    height: 280,
    padding: 12,
    overflow: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
  },
  footer: {
    padding: '12px 16px',
    background: '#FFF',
  },
  sendButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    borderRadius: 4,
    padding: 12,
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 700,
    cursor: 'pointer',
    border: 0,
    color: '#FFF',
    background: '#1658F3',

    '& > svg': {
      marginRight: 8,
    },

    '&:disabled': {
      color: 'rgba(53, 64, 82, 0.7)',
      background: 'rgba(53, 64, 82, 0.1) !important',
      cursor: 'default',
    },
  },
})
